import styled from 'styled-components';
import MiniSBGameModes from 'bdata-sns-shared/mini/types/MiniSBGameModes';
import COLORMAP from 'bdata-sns-shared/style/universal.color';

export const GameCardsProps = {
    infinity: {
        width: '160px',
        height: '84px'
    },
    gameday: {
        width: '125px',
        height: '74px'
    },
    vertical: {
        width: '375px',
        height: '64px'
    }
};

const GameWrapper = styled.div.attrs({
    'data-mlb-test': 'singleGameContainer'
})`
    background: transparent;
    width: 100%;
    flex-shrink: 0;
    transition-duration: .2s;
    min-height: 65px;
    font-family: ${({ theme }) => theme.fonts.family.primary};
    
    ${({ mode }) => mode === MiniSBGameModes.INFINITY || mode === MiniSBGameModes.GAMEDAY
        ? `
            cursor: pointer;
            width: ${GameCardsProps[MiniSBGameModes.INFINITY].width};
            height: ${GameCardsProps[MiniSBGameModes.INFINITY].height};
            margin-bottom: 0;
            white-space:nowrap;
            box-sizing: border-box;
            position: relative;
            border-color: ${COLORMAP.borderColor};
            border-style: solid;
            border-width: 1px 1px 1px 0;
            margin-bottom: 0;

            &:hover {
                transform: none;
                box-shadow: none;
                border-radius: 0;
            }
        `
        : ''
}

    ${({ mode }) => mode === MiniSBGameModes.GAMEDAY
        ? `
            width: ${GameCardsProps[MiniSBGameModes.GAMEDAY].width};
            height: ${GameCardsProps[MiniSBGameModes.GAMEDAY].height};
        `
        : ''
}

    ${({ mode }) => mode === MiniSBGameModes.VERTICAL
        ? `
            width: ${GameCardsProps[MiniSBGameModes.VERTICAL].width};
            height: ${GameCardsProps[MiniSBGameModes.VERTICAL].height};
        ` : ''
}
`;

export default GameWrapper;
